import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import Popup from './components/popup';
import QrScanner from './components/qrscan';
import SafeDy from './components/safe';
import JsonData from "./data/data.json";
import LedgerBanners from "./components/LedgerBanners";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <div>
        <Navigation />
        <Routes>
          {/* Home Route */}
          <Route
            path="/"
            element={
              <>
                <Header data={landingPageData.Header} />
                <Features data={landingPageData.Features} />
                <About data={landingPageData.About} />
                <Services data={landingPageData.Services} />
                <Gallery data={landingPageData.Gallery} />
                <Team data={landingPageData.Team} />
                <Contact data={landingPageData.Contact} />
                <Popup />
                <LedgerBanners />
              </>
            }
          />
          {/* QR Scanner Route */}
          <Route path="/qrscan" element={<QrScanner />} />
          <Route path="/savemywords" element={<SafeDy />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
